import { stenaStatisticsBar } from "@stenajs-webui/elements";
import * as React from "react";
import { useFilterWorkspace } from "../../hooks/UseFilterWorkspace";
import { RangeFilter } from "../../types/RangeFilter";
import { FppSearchFilterSection } from "../FppSearchFilterSection";
import { RangeControl } from "../RangeControl";

interface Props {
  enabled?: boolean;
  label?: string;
  labelFrom?: string;
  labelTo?: string;
  maxDecimals?: number;
  maxNumbers?: number;
}

export const NetworkVolumeFilterSection: React.FC<Props> = ({
  enabled,
  label,
  labelFrom,
  labelTo,
  maxDecimals,
  maxNumbers,
}) => {
  const { networkVolume, setNetworkVolume } = useFilterWorkspace();

  const onFilterValueChange = (rangeFilter: RangeFilter) => {
    setNetworkVolume({ ...rangeFilter });
  };

  const numberOfActiveFilters = () => {
    return networkVolume.from || networkVolume.to ? 1 : 0;
  };

  return (
    <FppSearchFilterSection
      sectionId={"networkVolume"}
      label={label}
      enabled={enabled}
      numSelected={numberOfActiveFilters()}
      leftIcon={stenaStatisticsBar}
      children={
        <RangeControl<RangeFilter>
          value={networkVolume}
          valueFrom={networkVolume.from}
          valueTo={networkVolume.to}
          onValueChange={onFilterValueChange}
          labelFrom={labelFrom ?? "From"}
          labelTo={labelTo ?? "To"}
          maxNumbers={6}
          maxDecimals={maxDecimals}
        />
      }
    />
  );
};
